export default{sources:{avif:"__VITE_ASSET__jzltYCOc__ 221w",webp:"__VITE_ASSET__BDW$0BlN__ 221w"},img:{src:"__VITE_ASSET__UGMAInJn__",w:221,h:72}};